/** Reserved formData key for per-section user-defined fields (title + value). */
export const SECTION_CUSTOM_FIELDS_KEY = "__sectionCustomFields__";
